export default __webpack_public_path__ + "static/media/yield_tokens.98c2aaf8.svg";